import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q667fpxnjn: FaireBrandEntity = {
  token: "b_q667fpxnjn",
  type: "brand",
  name: "Square Deal Recordings & Supplies",
  avatarUrl:
    "https://cdn.faire.com/fastly/5d4e1283dee77b0836be49e9788839058c280453d5ad1d22f669ea560c8ddfec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b71315932b970afbaed99d0c3662484b091fdb1ab36f47db625d74c9febcd784.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5d4e1283dee77b0836be49e9788839058c280453d5ad1d22f669ea560c8ddfec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b71315932b970afbaed99d0c3662484b091fdb1ab36f47db625d74c9febcd784.png",
  location: "San Luis Obispo, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 301,
  isTopShop: true,
  isInsider: true,
  description:
    "We’ve been creating, packing, and shipping products with personality since 1972! From our home base in San Luis Obispo, California, Square Deal is a second-generation, family-owned business offering thousands of fun, affordable designs that make customers smile and stores stand out.\nWe specialize in buttons, patches, stickers, enamel pins, magnets, and keychains — covering music, pop culture, humor, and art. Everything we make is designed to sell fast, display easily, and bring a little extra personality to any shop.\nWe also have deep roots in music. Our record sleeves and media supplies have been trusted by collectors and indie shops for decades. You’ll find professional-grade sleeves and replacement cases for vinyl records, CDs, DVDs, Blu-Ray, cassette tapes, and video games including PS4, Xbox, Switch, and more.\nFamily-owned and operated for over 50 years, we’re proud to keep things hands-on: quick shipping, real people, and genuine appreciation for every customer. Whether your shop’s vibe is bold, funny, or nostalgic, you’ll find something that hits the right note in our ever-growing lineup.\nFollow us on Instagram & Facebook: @squaredealonline\nand X: @squaredealslo",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:16.852Z",
    importedBy: "entity-db-cli",
  },
};
